export default __webpack_public_path__ + "static/media/deauville04.4e2b95f3.jpg";